// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__odmE9","header":"ReportDetails_header__2eY5_","title":"ReportDetails_title__1SE6a","left":"ReportDetails_left__1zYkK"};